import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-heart-fill',
  templateUrl: './icon-heart-fill.component.html',
  styleUrls: ['./icon-heart-fill.component.scss'],
})
export class IconHeartFillComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
